window.refreshOverviewPayments = function() {
    function InitPopups() {
        $('#divLinkInvoice' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: "#contentView",
            close: function() {
                $('#txtFindInvoicePatientName' + viewbagUniquePrefix).val('');
                $('#txtFindInvoiceOrderNumber' + viewbagUniquePrefix).val('');
                $('#txtFindInvoiceInvoiceNumber' + viewbagUniquePrefix).val('');
                $('#txtFindInvoiceAmount' + viewbagUniquePrefix).val('')
                $('#txtFindInvoiceUnpaid' + viewbagUniquePrefix).prop('checked', true);
                $('#txtFindInvoicePaymentId' + viewbagUniquePrefix).val('');
                $('#datepickerFromFindInvoice').val('');
                $('#datepickerToFindInvoice').val('');
                $('#gridLinkInvoice' + viewbagUniquePrefix + ' ' + 'tr').remove();
                $('#btnLinkSelectedInvoice'+ viewbagUniquePrefix).prop("disabled",true);
                $(".linkedInvoice-validation-error").css('display', 'none');
            },
            title: $("<div/>").html(window.Resources.LinkInvoice).text()
        });

        $('#divUnlinkInvoice' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: "#contentView",
            close: function() {
                $('#txtUnlinkPaymentId' + viewbagUniquePrefix).val('');
            },
            title: $("<div/>").html(window.Resources.UnlinkInvoice).text()
        });

        $('#divIgnorePayment' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: "#contentView",
            close: function() {
                $('#txIgnorePaymentId' + viewbagUniquePrefix).val('');
            },
            title: $("<div/>").html(window.Resources.IgnorePayment).text()
        });

        $('input#txtFindInvoiceAmount' + viewbagUniquePrefix).ForcePositiveNegativeNumericOnly();

        var frompicker = '<p class="fromPicker findInvoice"><input id="datepickerFromFindInvoice" type="text" disabled="disabled"/></p>';
        var topicker = '<div class="betweenPickers"> - </div><p class="toPicker findInvoice"><input id="datepickerToFindInvoice" type="text" disabled="disabled"/></p><p><div class="clearButtonFindInvoice">Clear</div> <div class="or">' + window.Resources.or + '</div><span id="showAllFindInvoice">' + window.Resources.ShowAll + '</span></p>';

        var clearDatePickerWrapper = false;

        var dateToShow = "";
        if ($('input#datepickerFromFindInvoice').hasClass('activeDate')) {
            dateToShow = $('input#datepickerFromFindInvoice').val();
        }

        if ($('input#datepickerFromFindInvoice').hasClass('hasDatepicker')) {
            dateToShow = $('input#datepickerFromFindInvoice').val();
            clearDatePickerWrapper = true;
        }

        var dateToShowTo = "";
        if ($('input#datepickerToFindInvoice').hasClass('activeDate')) {
            dateToShowTo = $('input#datepickerToFindInvoice').val();
        }

        if ($('input#datepickerToFindInvoice').hasClass('hasDatepicker')) {
            dateToShowTo = $('input#datepickerToFindInvoice').val();
            clearDatePickerWrapper = true;
        }

        if (clearDatePickerWrapper) {
            $('#datepickerWrapperFindInvoice').empty();
        }

        $('#datepickerWrapperFindInvoice').append(frompicker);
        $('#datepickerWrapperFindInvoice').append(topicker);


        $('input#datepickerFromFindInvoice').datepicker({
            dateFormat: 'dd/mm/yy',
            showOn: "button",
            buttonImage: '/Content/img/icnDatepicker.png',
            buttonText: window.Resources.SelectDate,
            buttonImageOnly: false,
            autoSize: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            showWeek: true,
            changeMonth: true,
            changeYear: true,
            firstDay: 1,
            monthNames: [window.Resources.January, window.Resources.February, window.Resources.March, window.Resources.April, window.Resources.May, window.Resources.June, window.Resources.July, window.Resources.August, window.Resources.September, window.Resources.October, window.Resources.November, window.Resources.December],
            monthNamesShortType: [window.Resources.JanuaryAbbr, window.Resources.FebruaryAbbr, window.Resources.MarchAbbr, window.Resources.AprilAbbr, window.Resources.MayAbbr, window.Resources.JuneAbbr, window.Resources.JulyAbbr, window.Resources.AugustAbbr, window.Resources.SeptemberAbbr, window.Resources.OctoberAbbr, window.Resources.NovemberAbbr, window.Resources.DecemberAbbr],
            onSelect: function (dateText, inst) {
                $(this).data('datepicker').inline = true;
                $('input#datepickerFromFindInvoice').val(dateText);
                $('input#datepickerFromFindInvoice').attr('value', dateText);
                $('input#datepickerToFindInvoice').datepicker("option", "minDate", moment(dateText, "DD/MM/YYYY").toDate());
                $('span#showAllFindInvoice').removeClass('activeAll');
                $('input#datepickerFromFindInvoice').addClass('activeDate');
            },
            onClose: function () {
                $(this).data('datepicker').inline = false;
            }
        });

        $('input#datepickerFromFindInvoice').datepicker("setDate", dateToShow);
        $('input#datepickerFromFindInvoice').attr('value', dateToShow);
        $('input#datepickerFromFindInvoice').val(dateToShow);

        $('input#datepickerToFindInvoice').datepicker({
            dateFormat: 'dd/mm/yy',
            showOn: "button",
            buttonImage: '/Content/img/icnDatepicker.png',
            buttonText: window.Resources.SelectDate,
            buttonImageOnly: false,
            autoSize: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            showWeek: true,
            changeMonth: true,
            changeYear: true,
            firstDay: 1,
            monthNames: [window.Resources.January, window.Resources.February, window.Resources.March, window.Resources.April, window.Resources.May, window.Resources.June, window.Resources.July, window.Resources.August, window.Resources.September, window.Resources.October, window.Resources.November, window.Resources.December],
            monthNamesShortType: [window.Resources.JanuaryAbbr, window.Resources.FebruaryAbbr, window.Resources.MarchAbbr, window.Resources.AprilAbbr, window.Resources.MayAbbr, window.Resources.JuneAbbr, window.Resources.JulyAbbr, window.Resources.AugustAbbr, window.Resources.SeptemberAbbr, window.Resources.OctoberAbbr, window.Resources.NovemberAbbr, window.Resources.DecemberAbbr],
            onSelect: function (dateText, inst) {
                $(this).data('datepicker').inline = true;
                $('input#datepickerToFindInvoice').val(dateText);
                $('input#datepickerToFindInvoice').attr('value', dateText);
                $('input#datepickerFromFindInvoice').datepicker("option", "maxDate", moment(dateText, "DD/MM/YYYY").toDate());
                $('span#showAllFindInvoice').removeClass('activeAll');
                $('input#datepickerToFindInvoice').addClass('activeDate');
            },
            onClose: function () {
                $(this).data('datepicker').inline = false;
            }
        });

        if (dateToShow == "") {
            $('span#showAllFindInvoice').addClass('activeAll');
            $('input#datepickerFromFindInvoice').removeClass('activeDate');
            $('input#datepickerToFindInvoice').removeClass('activeDate');
        }
        else {
            $('span#showAllFindInvoice').removeClass('activeAll');
            $('input#datepickerFromFindInvoice').addClass('activeDate');
            $('input#datepickerToFindInvoice').datepicker("option", "minDate", moment(dateToShow, "DD/MM/YYYY").toDate());
        }

        if (dateToShowTo != "") {
            $('input#datepickerToFindInvoice').datepicker("setDate", dateToShowTo);
            $('input#datepickerToFindInvoice').attr('value', dateToShowTo);
            $('input#datepickerToFindInvoice').val(dateToShowTo);
            $('input#datepickerToFindInvoice').addClass('activeDate');
            $('input#datepickerFromFindInvoice').datepicker("option", "maxDate", moment(dateToShowTo, "DD/MM/YYYY").toDate());
        }

        $("button.ui-datepicker-trigger").hover(
            function () {
                if ($(this).parent().hasClass('fromPicker') && $(this).parent().hasClass('findInvoice')) {
                    $('input#datepickerFromFindInvoice').css("background-color", "#FFFFE0");
                }
                else {
                    $('input#datepickerToFindInvoice').css("background-color", "#FFFFE0");
                }

            }, function () {
                if ($(this).parent().hasClass('fromPicker') && $(this).parent().hasClass('findInvoice')) {
                    $('input#datepickerFromFindInvoice').css("background-color", "inherit");
                }
                else {
                    $('input#datepickerToFindInvoice').css("background-color", "inherit");
                }
            }
        );

        $('body').on('click', '.clearButtonFindInvoice', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();

            $('input#datepickerToFindInvoice').val('');
            $('input#datepickerToFindInvoice').attr('value', '');
            $('input#datepickerToFindInvoice').removeClass('activeDate');
            $('input#datepickerFromFindInvoice').datepicker("option", "maxDate", '');
        });

        $('span#showAllFindInvoice').on('click', function (e) {
            $('span#showAllFindInvoice').addClass('activeAll');
            $('input#datepickerFromFindInvoice').removeClass('activeDate');
            $('input#datepickerFromFindInvoice').removeAttr('value');
            $('input#datepickerFromFindInvoice').val("");
            $('input#datepickerToFindInvoice').removeClass('activeDate');
            $('input#datepickerToFindInvoice').removeAttr('value');
            $('input#datepickerToFindInvoice').val("");
        });
    }
    function InitDatePickers() {
        var frompicker = '<p class="fromPicker"><input id="datepickerFrom" type="text" disabled="disabled"/></p>';
        var topicker = '<div class="betweenPickers"> - </div><p class="toPicker"><input id="datepickerTo" type="text" disabled="disabled"/></p><p><div class="clearButton">Clear</div> <div class="or">' + window.Resources.or + '</div><span id="showAll">' + window.Resources.ShowAll + '</span></p>';

        var clearDatePickerWrapper = false;

        var dateToShow = "";
        if ($('input#datepickerFrom').hasClass('activeDate')) {
            dateToShow = $('input#datepickerFrom').val();
        }
        else {
            dateToShow = moment().format("DD/MM/YYYY");
        }

        if ($('input#datepickerFrom').hasClass('hasDatepicker')) {
            dateToShow = $('input#datepickerFrom').val();
            clearDatePickerWrapper = true;
        }

        var dateToShowTo = "";
        if ($('input#datepickerTo').hasClass('activeDate')) {
            dateToShowTo = $('input#datepickerTo').val();
        }

        if ($('input#datepickerTo').hasClass('hasDatepicker')) {
            dateToShowTo = $('input#datepickerTo').val();
            clearDatePickerWrapper = true;
        }

        if (clearDatePickerWrapper) {
            $('#datepickerWrapper').empty();
        }

        $('#datepickerWrapper').append(frompicker);
        $('#datepickerWrapper').append(topicker);


        $('input#datepickerFrom').datepicker({
            dateFormat: 'dd/mm/yy',
            showOn: "button",
            buttonImage: '/Content/img/icnDatepicker.png',
            buttonText: window.Resources.SelectDate,
            buttonImageOnly: false,
            autoSize: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            showWeek: true,
            changeMonth: true,
            changeYear: true,
            firstDay: 1,
            monthNames: [window.Resources.January, window.Resources.February, window.Resources.March, window.Resources.April, window.Resources.May, window.Resources.June, window.Resources.July, window.Resources.August, window.Resources.September, window.Resources.October, window.Resources.November, window.Resources.December],
            monthNamesShortType: [window.Resources.JanuaryAbbr, window.Resources.FebruaryAbbr, window.Resources.MarchAbbr, window.Resources.AprilAbbr, window.Resources.MayAbbr, window.Resources.JuneAbbr, window.Resources.JulyAbbr, window.Resources.AugustAbbr, window.Resources.SeptemberAbbr, window.Resources.OctoberAbbr, window.Resources.NovemberAbbr, window.Resources.DecemberAbbr],
            onSelect: function (dateText, inst) {
                $(this).data('datepicker').inline = true;
                $('input#datepickerFrom').val(dateText);
                $('input#datepickerFrom').attr('value', dateText);
                $('input#datepickerTo').datepicker("option", "minDate", moment(dateText, "DD/MM/YYYY").toDate());
                $('span#showAll').removeClass('activeAll');
                $('input#datepickerFrom').addClass('activeDate');
                refreshTable();
            },
            onClose: function () {
                $(this).data('datepicker').inline = false;
            }
        });

        $('input#datepickerFrom').datepicker("setDate", dateToShow);
        $('input#datepickerFrom').attr('value', dateToShow);
        $('input#datepickerFrom').val(dateToShow);

        $('input#datepickerTo').datepicker({
            dateFormat: 'dd/mm/yy',
            showOn: "button",
            buttonImage: '/Content/img/icnDatepicker.png',
            buttonText: window.Resources.SelectDate,
            buttonImageOnly: false,
            autoSize: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            showWeek: true,
            changeMonth: true,
            changeYear: true,
            firstDay: 1,
            monthNames: [window.Resources.January, window.Resources.February, window.Resources.March, window.Resources.April, window.Resources.May, window.Resources.June, window.Resources.July, window.Resources.August, window.Resources.September, window.Resources.October, window.Resources.November, window.Resources.December],
            monthNamesShortType: [window.Resources.JanuaryAbbr, window.Resources.FebruaryAbbr, window.Resources.MarchAbbr, window.Resources.AprilAbbr, window.Resources.MayAbbr, window.Resources.JuneAbbr, window.Resources.JulyAbbr, window.Resources.AugustAbbr, window.Resources.SeptemberAbbr, window.Resources.OctoberAbbr, window.Resources.NovemberAbbr, window.Resources.DecemberAbbr],
            onSelect: function (dateText, inst) {
                $(this).data('datepicker').inline = true;
                $('input#datepickerTo').val(dateText);
                $('input#datepickerTo').attr('value', dateText);
                $('input#datepickerFrom').datepicker("option", "maxDate", moment(dateText, "DD/MM/YYYY").toDate());
                $('span#showAll').removeClass('activeAll');
                $('input#datepickerTo').addClass('activeDate');
                refreshTable();
            },
            onClose: function () {
                $(this).data('datepicker').inline = false;
            }
        });

        if (dateToShow == "") {
            $('span#showAll').addClass('activeAll');
            $('input#datepickerFrom').removeClass('activeDate');
            $('input#datepickerTo').removeClass('activeDate');
        }
        else {
            $('span#showAll').removeClass('activeAll');
            $('input#datepickerFrom').addClass('activeDate');
            $('input#datepickerTo').datepicker("option", "minDate", moment(dateToShow, "DD/MM/YYYY").toDate());
        }

        if (dateToShowTo != "") {
            $('input#datepickerTo').datepicker("setDate", dateToShowTo);
            $('input#datepickerTo').attr('value', dateToShowTo);
            $('input#datepickerTo').val(dateToShowTo);
            $('input#datepickerTo').addClass('activeDate');
            $('input#datepickerFrom').datepicker("option", "maxDate", moment(dateToShowTo, "DD/MM/YYYY").toDate());
        }

        $("button.ui-datepicker-trigger").hover(
            function () {
                if ($(this).parent().hasClass('fromPicker')) {
                    $('input#datepickerFrom').css("background-color", "#FFFFE0");
                }
                else {
                    $('input#datepickerTo').css("background-color", "#FFFFE0");
                }

            }, function () {
                if ($(this).parent().hasClass('fromPicker')) {
                    $('input#datepickerFrom').css("background-color", "inherit");
                }
                else {
                    $('input#datepickerTo').css("background-color", "inherit");
                }
            }
        );
    }

    function InitTable() {
        var firstSetup = true;
        if ($('div#tableWrapper').find('#tableOverviewPayments' + viewbagUniquePrefix + '_wrapper').length > 0) {
            filter = $('div#tableOverviewPayments' + viewbagUniquePrefix + '_filter').find('input').val();
            $('div#tableWrapper').empty();
            $('div#tableWrapper').html('<table id="tableOverviewPayments' + viewbagUniquePrefix + '"></table>');
            firstSetup = false;
        }

        tableOverviewPayments = $('div#tableWrapper').find('#tableOverviewPayments' + viewbagUniquePrefix + '').dataTable({
            "oSearch": { "sSearch": filter },
            "bDestroy": true,
            "bStateSave": true,
            "bProcessing": true,
            "bServerSide": true,
            "aaSorting": [[1, "desc"]],
            "sAjaxSource": "/legacy/Invoices/GetPaymentsOverview",
            "sAjaxDataProp": "aData",
            "aoColumns": [
                {
                    "mData": "PaymentMethod", "sTitle": window.Resources.PaymentMethod, "sClass": "pr5 center", "bSortable": false,
                    "mRender": function (data, type, full) {
                        return data + '<span class="invoiceId hidden">' + full['InvoiceId'] + '</span>' + '<span class="orderId hidden">' + full['OrderId'] + '</span>';
                    }
                },
                { "mData": "BankTransferId", "sTitle": window.Resources.BankTransferId, "sClass": "pr3 center", "bSortable": false },
                { "mData": "PayerInformation", "sTitle": window.Resources.PayerInformation, "sClass": "pr5", "bSortable": false },
                { "mData": "BankTransferAccountFrom", "sTitle": window.Resources.BankTransferPayerAccount, "sClass": "pr5", "bSortable": false },
                { "mData": "BankTransferAccountTo", "sTitle": window.Resources.BankTransferReceiverAccount, "sClass": "pr5", "bSortable": false },
                {
                    "mData": "Amount", "sTitle": window.Resources.Amount, "sClass": "pr3 center", "bSortable": false,
                    "mRender": function (data, type, full) {
                        return "&euro; " + data.toFixed(2).toString();
                    }
                },
                { "mData": "ReferenceNumber", "sTitle": window.Resources.BankReferenceNumber, "sClass": "pr5 center", "bSortable": false },
                { "mData": "Message", "sTitle": window.Resources.Message, "sClass": "pr5 center", "bSortable": false },
                {
                    "mData": "Datetime", "sTitle": window.Resources.Date, "sClass": "pr5 center", "bSortable": false,
                    "mRender": function (data, type, full) {
                        var m = moment(data, "MM/DD/YYYY hh:mm:ss A");
                        return m.calendar();
                    }},
                { "mData": "InvoiceNumber", "sTitle": window.Resources.ReferenceNumber, "sClass": "pr5 center", "bSortable": false },
                {
                    "mData": "MatchStatus", "sTitle": window.Resources.Status, "sClass": "pr5 center", "bSortable": false,
                    "mRender": function (data, type, full) {
                        if (full.MatchStatusId == 0) {
                            return data + '<span className="notLinked hidden"></span>';
                        }
                        if (full.MatchStatusId == ignoredMatchStatus || full.MatchStatusId == notLinkedMatchStatus) {
                            return data + '<span class="notLinked hidden"></span>';
                        }
                        return data;
                    }
                },
                {
                    "mData": null, "sTitle": window.Resources.Action, "sClass": "pr4 center", "bSortable": false,
                    "mRender": function (data, type, full) {
                        if (full.MatchStatusId == ignoredMatchStatus) {
                            return '<i class="fas fa-link fa-lg linkInvoiceIcon" title="' + window.Resources.LinkInvoice + '"></i><label class="linkInvoice hidden" data-paymentId="' + full.PaymentId + '" + data-amount="' + full.Amount + '"></label>';
                        }
                        if (full.MatchStatusId == notLinkedMatchStatus) {
                            return '<i class="fas fa-link fa-lg linkInvoiceIcon" title="' + window.Resources.LinkInvoice + '"></i><label class="linkInvoice hidden" data-paymentId="' + full.PaymentId + '" + data-amount="' + full.Amount + '"></label>' + ' ' +
                                '<i class="fas fa-ban fa-lg ignorePaymentIcon" title="' + window.Resources.IgnorePayment + '"></i><label class="ignorePayment hidden" data-paymentId="' + full.PaymentId + '"></label>';
                        }
                        if (full.MatchStatusId == linkedMatchStatus) {
                            return '<i class="fas fa-unlink fa-lg unlinkInvoiceIcon" title="' + window.Resources.UnlinkInvoice + '"></i><label class="unlinkInvoice hidden" data-paymentId="' + full.PaymentId + '"></label>' + ' ' +
                                '<i class="fas fa-ban fa-lg ignorePaymentIcon" title="' + window.Resources.IgnorePayment + '"></i><label class="ignorePayment hidden" data-paymentId="' + full.PaymentId + '"></label>';
                        }
                        return null;
                    }
                },
            ],
            "fnCreatedRow" : function(nRow, aData, iDataIndex) {
                if (aData.InvoiceId == null)
                {
                    $(nRow).addClass('noLink');
                }
            },
            "iDisplayLength": 20,
            "aLengthMenu": [[10, 20, 50, 100], [10, 20, 50, 100]],
            "oLanguage": {
                "sSearch": "",
                "sLengthMenu": "_MENU_",
                "sInfo": '<strong>_START_</strong>-<strong>_END_</strong> ' + window.Resources.From + ' <strong>_TOTAL_</strong>',
                "sInfoFiltered": '(' + window.Resources.From + ' <strong>_MAX_</strong>)',
                "sInfoEmpty": '<strong>0</strong> ' + window.Resources.From + ' <strong>0</strong>',
                "sProcessing": window.Resources.Loading,
                "sZeroRecords": window.Resources.NoResultsFound,
                "sEmptyTable": window.Resources.NoResultsFound,
                "sInfoThousands": ".",
                "sLoadingRecords": window.Resources.Loading,
                "oPaginate": {
                    "sFirst": window.Resources.First,
                    "sLast": window.Resources.Last,
                    "sNext": window.Resources.Next,
                    "sPrevious": window.Resources.Previous
                }
            },
            "sPaginationType": "full_numbers",
            "fnInitComplete": function (oSettings, json) {
                $("#tableOverviewPayments" + viewbagUniquePrefix + "_filter input").attr("value", filter);

                $(matchingStatusDropdown).insertAfter('div.dataTables_filter label');
                $('#MatchingStatus').on('change', function (e) {
                    $('#MatchingStatus').val($(this).val());
                    $('#MatchingStatus').attr('value', $(this).val());
                    refreshTable();
                });
            },
            "fnServerParams": function ( aoData ) {
                aoData.push({ "name": "matchingStatus", "value": $('#MatchingStatus').val() });
                aoData.push({ "name": "dateFrom", "value": $('input#datepickerFrom').val() });
                aoData.push({ "name": "dateTo", "value": $('input#datepickerTo').val() });
                aoData.push({ "name": "paymentsAllDates", "value": $('span#showAll').hasClass('activeAll') });
                aoData.push({ "name": "exportOverview", "value": exportOverview });
            },
            "fnDrawCallback": function (oSettings, json) {
                $("#tableOverviewPayments" + viewbagUniquePrefix + ' ' + 'tbody tr td i.linkInvoiceIcon').off();
                $("#tableOverviewPayments" + viewbagUniquePrefix + ' ' + 'tbody tr td').on('click', 'i.linkInvoiceIcon', function (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    $('#txtFindInvoiceAmount' + viewbagUniquePrefix).val($(this).next().attr('data-amount'));
                    $('#txtFindInvoicePaymentId' + viewbagUniquePrefix).val($(this).next().attr('data-paymentId'))
                    $('#divLinkInvoice' + viewbagUniquePrefix).dialog("open");
                });

                $("#tableOverviewPayments" + viewbagUniquePrefix + ' ' + 'tbody tr td i.unlinkInvoiceIcon').off();
                $("#tableOverviewPayments" + viewbagUniquePrefix + ' ' + 'tbody tr td').on('click', 'i.unlinkInvoiceIcon', function (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    $('#txtUnlinkPaymentId' + viewbagUniquePrefix).val($(this).next().attr('data-paymentId'))
                    $('#divUnlinkInvoice' + viewbagUniquePrefix).dialog("open");
                });

                $("#tableOverviewPayments" + viewbagUniquePrefix + ' ' + 'tbody tr td i.ignorePaymentIcon').off();
                $("#tableOverviewPayments" + viewbagUniquePrefix + ' ' + 'tbody tr td').on('click', 'i.ignorePaymentIcon', function (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    $('#txtIgnorePaymentId' + viewbagUniquePrefix).val($(this).next().attr('data-paymentId'))
                    $('#divIgnorePayment' + viewbagUniquePrefix).dialog("open");
                });
            }
        });

        if ($('div#tableOverviewPayments' + viewbagUniquePrefix + '_filter').find('input').val() == "") {
            $('div#tableOverviewPayments' + viewbagUniquePrefix + '_filter').find('input').attr('placeholder', $("<div/>").html(window.Resources.FilterOn + ' ' + window.Resources.Name + ' ' + window.Resources.or + ' ' + window.Resources.AccountFrom + ' ' + window.Resources.or + ' ' + window.Resources.AccountTo).text());
        }
    }

    var filter = "";
    var tableOverviewPayments;
    var exportOverview = false;

    if (typeof ($('#MatchingStatus').attr('value')) !== "undefined") {
        $('#MatchingStatus').val($('#MatchingStatus').attr('value'));
    }

    InitPopups();
    InitDatePickers();
    InitTable();

    /*#region EVENTS*/

    $('button#btnCloseIgnorePaymentDialog' + viewbagUniquePrefix).on('click', function (e) {
        $('#divIgnorePayment' + viewbagUniquePrefix).dialog("close");
    });

    $('button#btnCloseUnlinkInvoiceDialog' + viewbagUniquePrefix).on('click', function (e) {
        $('#divUnlinkInvoice' + viewbagUniquePrefix).dialog("close");
    });

    $('button#btnCloseLinkInvoiceDialog' + viewbagUniquePrefix).on('click', function (e) {
        $('#divLinkInvoice' + viewbagUniquePrefix).dialog("close");
    });

    $('button#btnSearchLinkInvoiceDialog' + viewbagUniquePrefix).on('click', function (e) {
        e.preventDefault();
        findInvoices();
    });

    $('#divLinkInvoice' + viewbagUniquePrefix + ' .searchOnEnter').on('keydown', function (e) {
        if (e.keyCode == 13) {
            findInvoices();
            return false;
        }
    });

    $('#gridLinkInvoice' + viewbagUniquePrefix).on('click', 'tr.record', function (e) {
        $(this).parent().find('tr.focus').removeClass('focus');
        $(this).addClass('focus');
        $("#btnLinkSelectedInvoice" + viewbagUniquePrefix).removeAttr("disabled");
    });

    $('#gridLinkInvoice' + viewbagUniquePrefix).on('dblclick', 'tr.record', function (e) {
        $(this).parent().find('tr.focus').removeClass('focus');
        $(this).addClass('focus');
        $("#btnLinkSelectedInvoice" + viewbagUniquePrefix).removeAttr("disabled");
        LinkSelectedInvoice();
    });

    $('#btnIgnoreSelectedPayment' + viewbagUniquePrefix).on('click', function (e) {
        IgnoreSelectedPayment();
    });

    $('#btnUnlinkSelectedInvoice' + viewbagUniquePrefix).on('click', function (e) {
        UnlinkSelectedInvoice();
    });

    $('#btnLinkSelectedInvoice' + viewbagUniquePrefix).on('click', function (e) {
        LinkSelectedInvoice();
    });

    $('body').on('click', '.clearButton', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        $('input#datepickerTo').val('');
        $('input#datepickerTo').attr('value', '');
        $('input#datepickerTo').removeClass('activeDate');
        $('input#datepickerFrom').datepicker("option", "maxDate", '');
        refreshTable();
    });

    $('span#showAll').on('click', function (e) {
        $('span#showAll').addClass('activeAll');
        $('input#datepickerFrom').removeClass('activeDate');
        $('input#datepickerFrom').removeAttr('value');
        $('input#datepickerFrom').val("");
        $('input#datepickerTo').removeClass('activeDate');
        $('input#datepickerTo').removeAttr('value');
        $('input#datepickerTo').val("");
        refreshTable();
    });

    $('#tableOverviewPayments' + viewbagUniquePrefix + ' ' + 'tbody').on('click', 'tr', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        if (!$(this).hasClass("noLink")){
            var invoiceId = $(this).find('span.invoiceId').text();
            if (invoiceId) {
                useFilingCabinet('/Invoices/DetailConfirmed/' + invoiceId);
            } else {
                var orderId = $(this).find('span.orderId').text();
                if (orderId) {
                    useFilingCabinet('/Orders/Detail/' + orderId);
                }
            }
        }
    });

    $('input#btnExportOverviewPayments').on('click', function (e) {
        exportOverview = true;
        filter = $('div#tableOverviewPayments' + viewbagUniquePrefix + '_filter').find('input').val();
        tableOverviewPayments.fnFilter(filter);
        exportOverview = false;
        return false;
    });

    $('#tableOverviewPayments' + viewbagUniquePrefix + '_filter input').unbind();
    $('#tableOverviewPayments' + viewbagUniquePrefix + '_filter input').bind('keydown', function (e) {
        if (e.keyCode == 13) {
            filter = $('div#tableOverviewPayments' + viewbagUniquePrefix + '_filter').find('input').val();
            tableOverviewPayments.fnFilter(this.value);
            return false;
        }
    });

    /*#endregion*/

    var refreshTable = function () {
        filter = $('div#tableOverviewPayments' + viewbagUniquePrefix + '_filter').find('input').val();
        tableOverviewPayments.fnFilter(filter);
    }

    var findInvoices = function (e) {
        var patientName = $('#txtFindInvoicePatientName' + viewbagUniquePrefix).val();
        var orderNumber = $('#txtFindInvoiceOrderNumber' + viewbagUniquePrefix).val();
        var invoiceNumber = $('#txtFindInvoiceInvoiceNumber' + viewbagUniquePrefix).val();
        var amount = $('#txtFindInvoiceAmount' + viewbagUniquePrefix).val();
        var onlyUnpaid = $('#txtFindInvoiceUnpaid' + viewbagUniquePrefix).is(":checked");
        var dateFrom = $('#datepickerFromFindInvoice').val();
        var dateTo = $('#datepickerToFindInvoice').val();

        if (!patientName && !orderNumber && !invoiceNumber && !dateFrom && !dateTo) {
            $(".linkedInvoice-validation-error").css('display', 'inline');
            return;
        }
        $(".linkedInvoice-validation-error").css('display', 'none');

        $.ajax({
            type: 'POST',
            url: '/legacy/Invoices/FindInvoicesForGrid',
            data: {
                patientName: patientName,
                orderNumber: orderNumber,
                invoiceNumber: invoiceNumber,
                amount: amount,
                onlyUnpaid: onlyUnpaid,
                dateFrom: dateFrom,
                dateTo: dateTo
            },
            dataType: 'json',
            success:
                function (data) {
                    $('#gridLinkInvoice' + viewbagUniquePrefix + ' tr:not(.tableHeader)').remove();
                    $("#btnLinkSelectedInvoice" + viewbagUniquePrefix).attr("disabled", true);
                    if (data.items.length > 0) {
                        $.each(data.items, function (e) {
                            $('#gridLinkInvoice' + viewbagUniquePrefix).append('<tr class="record"><td class="rowId">' + this.ID + '</td><td class="rowName center">' + this.InvoiceNumber + '</td><td class="rowName">' + this.PatientName + '</td><td class="rowName">' + this.PatientAddress + '</td><td class="rowName center">&euro; ' + this.Amount + '</td><td class="rowName center">' + moment(this.DateTime_String).calendar() + '</td></tr>');
                        });
                    } else {
                        $('#gridLinkInvoice' + viewbagUniquePrefix).append('<tr class="noRecords"><td colspan="6">' + window.Resources.NoResultsFound + '</td></tr>');
                    }
                }
        });
    }

    var LinkSelectedInvoice = function (e) {
        var invoiceId = $('#gridLinkInvoice' + viewbagUniquePrefix).find('tr.focus').find('td.rowId').html();
        var paymentId = $('#txtFindInvoicePaymentId' + viewbagUniquePrefix).val();
        $.ajax({
            url: "/legacy/Invoices/LinkInvoiceToPayment",
            type: "POST",
            dataType: "json",
            async: false,
            data: {
                invoiceId: invoiceId,
                paymentId: paymentId
            },
            success: function (data) {
                $('#divLinkInvoice' + viewbagUniquePrefix).dialog("close");
                refreshTable();
            }
        });
    }

    var UnlinkSelectedInvoice = function (e) {
        var paymentId = $('#txtUnlinkPaymentId' + viewbagUniquePrefix).val();
        $.ajax({
            url: "/legacy/Invoices/UnlinkInvoiceFromPayment",
            type: "POST",
            dataType: "json",
            async: false,
            data: {
                paymentId: paymentId
            },
            success: function (data) {
                $('#divUnlinkInvoice' + viewbagUniquePrefix).dialog("close");
                refreshTable();
            }
        });
    }

    var IgnoreSelectedPayment = function (e) {
        var paymentId = $('#txtIgnorePaymentId' + viewbagUniquePrefix).val();
        $.ajax({
            url: "/legacy/Invoices/IgnorePayment",
            type: "POST",
            dataType: "json",
            async: false,
            data: {
                paymentId: paymentId
            },
            success: function (data) {
                $('#divIgnorePayment' + viewbagUniquePrefix).dialog("close");
                refreshTable();
            }
        });
    }

    $('#btnUpload').on('click', function(e){
        e.stopImmediatePropagation();
        e.preventDefault();

        if (window.FormData !== undefined) {

            $(this).attr("disabled",true);

            var fileUpload = $("#fileUpload").get(0);
            var files = fileUpload.files;

            // Create FormData object
            var fileData = new FormData();

            // Looping over all files and add it to FormData object
            for (var i = 0; i < files.length; i++) {
                fileData.append(files[i].name, files[i]);
            }

            resetProgressBar();

            $.ajax({
                url: '/legacy/Invoices/ImportCodaFile',
                type: "POST",
                contentType: false, // Not to set any content header
                processData: false, // Not to process data
                data: fileData,
                success: function(data){
                    if(data.AllOk)
                    {
                        $('#importTaskID').val(data.ImportTaskID);
                        $('#importSpinner').addClass('active');
                        $('#importSpinner').show();
                        $('.cancel').show();
                    }
                    else
                    {
                        $('#btnUpload').removeAttr("disabled");
                    }
                },
                error: function (err) {
                    alert(err.statusText);
                }
            });
        } else {
            alert("FormData is not supported.");
        }
    });

    function getImportStatus(){
        let importTaskID = $('#importTaskID').val();
        if(importTaskID)
        {
            $.ajax({
                url: '/legacy/Invoices/GetCodaImportStatus',
                type: "GET",
                dataType: 'json',
                data: {
                    taskID: importTaskID
                },
                success: function(data){
                    $("#myBar").css("width", data.ImportStatus.Percentage.toString() + '%');
                    $("#label").html(data.ImportStatus.Percentage.toString() + '%');
                    if(data.ImportStatus.Status === taskStatusReady || data.ImportStatus.Status === taskStatusError)
                    {
                        $('#importTaskID').val('');
                        $('#importSpinner').hide();
                        $('.cancel').hide();
                        $('#btnUpload').removeAttr("disabled");
                    }
                },
                error: function (err) {
                    alert(err.statusText);
                }
            });
        }
    }

    function resetProgressBar(){
        $("#myBar").css("width", '0%');
        $("#label").html('0%');
        $('#importTaskID').val('');
        $('#importSpinner').removeClass('active');
        $('#importSpinner').hide();
        $('.cancel').hide();
    }

    function cancelImport(){
        let importTaskID = $('#importTaskID').val();
        if(importTaskID)
        {
            $.ajax({
                url: '/legacy/Invoices/CancelImportCodaFile',
                type: "POST",
                dataType: 'json',
                data: {
                    taskID: importTaskID
                },
                success: function(){
                    resetProgressBar();

                    $('#btnUpload').removeAttr("disabled");
                },
                error: function (err) {
                    alert(err.statusText);
                }
            });
        }
    }

    $('.cancel').on('click', function(){
        cancelImport();
    });

    var refreshImportStatusInterval = setInterval(function (e) {
        getImportStatus();
    }, 10000);
    timeouts.push(refreshImportStatusInterval);

    window.onNavigateForRazor = async () => {
        clearTimeout(refreshImportStatusInterval);
    }
};
